import { HTMLAttributes } from 'react'
import { map } from 'lodash'
import Link from 'next/link'

import Container from '@/components/base/container'
import Grid from '@/components/base/grid'
import Section from '@/components/base/section'
import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type RetailsGridProps = HTMLAttributes<HTMLDivElement> &
  Partial<{
    items: {
      region: string
      retails: {
        name: string
        link: WPLink
      }[]
    }[]
  }>

const RetailsGrid = ({ items = [], ...props }: RetailsGridProps) => {
  return (
    <Section {...props}>
      <Container>
        <Grid className="gap-y-[5rem]">
          {map(items, ({ region, retails }, index) => (
            <div
              key={`item-${index}`}
              className={cn(
                'col-span-2 md:col-span-3 lg:col-span-4',
                'border-t border-black pt-[1rem]'
              )}
            >
              <div className="grid gap-y-[2rem]">
                {region ? (
                  <Typography variant="standard" component="h5" className="">
                    {region}
                  </Typography>
                ) : null}

                <ul className="grid gap-y-[0.15rem]">
                  {map(retails, ({ name, link }, index) => (
                    <li key={`retail-${index}`} className="">
                      {link && link.url ? (
                        <Link href={link.url} target={link.target} className="hover:underline">
                          <Typography className="font-helvetica text-[1.6rem] lowercase leading-[150%]">
                            {name}
                          </Typography>
                        </Link>
                      ) : name ? (
                        <Typography className="font-helvetica text-[1.6rem] lowercase leading-[150%]">
                          {name}
                        </Typography>
                      ) : null}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </Grid>
      </Container>
    </Section>
  )
}

export default RetailsGrid
